"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/spin/style/index.js
// module id = 116
// module chunks = 1